// extracted by mini-css-extract-plugin
export default {"Create_Team":"styles_Create_Team__SKj7I","icon__Wrap":"styles_icon__Wrap__pi1jw"};